import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClaimFormValidationService {
  private formValidationSubject = new Subject<void>();
  private validationResults = new Map<string, boolean>();
  private overallValidationSubject = new BehaviorSubject<boolean>(true);

  formValidationEvent$ = this.formValidationSubject.asObservable();
  validationResult$ = this.overallValidationSubject.asObservable();

  constructor() { }

  triggerFormValidation() {
    this.formValidationSubject.next();
  }

  updateValidationResult(componentId: string, isValid: boolean) {
    this.validationResults.set(componentId, isValid);
    this.evaluateOverallValidation();
  }

  private evaluateOverallValidation() {
    const allValid = Array.from(this.validationResults.values()).every(value => value);
    this.overallValidationSubject.next(allValid);
  }

}